import React from 'react';
import { Link } from 'react-router-dom';

import Card from './Card';
import DeviceCompareBlock from './DeviceCompareBlock';
import { joinClass } from '../helpers/component';
import { SWAPS_NEW, withQuery } from '../helpers/routes';

export default ({
  className = 'mb12',
  devices = [],
  action = false,
  isEligible = false,
}) => (
  <div className={joinClass('card-group', className)}>
    <div className="card-group__item">
      <Card className={joinClass(action && 'card--action-right-at-768')} action={action}>
        <h3>Device update details</h3>
      </Card>
    </div>
    {devices.map(device => (
      <div className="card-group__item" key={device.serialNumber}>
        <Card className="card--secondary">
          <DeviceCompareBlock device={device} />
        </Card>
      </div>
    ))}
    {isEligible && (
      <div className="card-group__item">
        <Card
          actionRight="desktop"
          action={(
            <Link to={withQuery(SWAPS_NEW)} className="button">
              Update Devices
            </Link>
          )}
        >
          <p className="body2">Want to update another device?</p>
        </Card>
      </div>
    )}

  </div>
);
